import { Component, OnInit } from '@angular/core';
import {
  GeneralSettingValue,
  GeneralSettingValueService,
  SocietiesService,
  Society,
} from '@pwc-bei/common';
import { switchMap } from 'rxjs';
import { EAccessPlanVariable } from 'src/app/enum/access-plan-variable';
import { RoutePath } from 'src/app/enums/route-path.enum';
import { CustomerDataService } from 'src/app/pages/services/customer-data.service';
import { AuthenticationUtilsService } from 'src/app/services/authentication-utils.service';
import { TermsAndConditionService } from 'src/app/services/terms-and-condition.service';
import { environment } from '../../../../environments/environment';
import { Router } from '@angular/router';
import { SharedDocumentService } from 'src/app/services/shared-document/shared-document.service';
import { SharedDocumentUploadService } from 'src/app/services/shared-document/shared-document-upload.service';
import { ESharedDocumentType } from 'src/app/enums/shared-document-type';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    standalone: false
})
export class FooterComponent implements OnInit {
  helpDeskEmail: string;
  currentYear = new Date().getFullYear();
  creationYearPlatform = 2022;
  directChannel = environment.directChannel;
  isUserSmart: boolean = false;

  constructor(
    private societiesService: SocietiesService,
    private generalSettingValueService: GeneralSettingValueService,
    private customerDataService: CustomerDataService,
    private termsConditionService: TermsAndConditionService,
    private authenticationUtilsService: AuthenticationUtilsService,
    private router: Router,
    private sharedDocumentService: SharedDocumentService,
    private sharedDocumentUploadService: SharedDocumentUploadService
  ) { }

  ngOnInit(): void {
    // this.helpDeskEmail = environment.helpDeskEmail;
    this.initHelpDeskEmail();
    this.isUserSmart = this.authenticationUtilsService.getAccessPlan(
      EAccessPlanVariable.IS_USER_SMART,
    );
  }


  private initHelpDeskEmail(): void {
    this.societiesService
      .getSelectedSociety()
      .pipe(
        switchMap((society: Society) =>
          this.generalSettingValueService.findByCode(
            'HELPDESK_EMAIL',
            society.id,
          ),
        ),
      )
      .subscribe((list: GeneralSettingValue[]) => {
        if (list == null || list.length === 0) {
          this.helpDeskEmail = environment.helpDeskEmail;
          return;
        }

        const setting = list[0];
        this.helpDeskEmail = setting.value;
      });
  }

  downloadGeneralConditions(): void {
    this.sharedDocumentUploadService.downloadDoc(ESharedDocumentType.GENERAL_CONDITIONS);
  }

  downloadPrivacyPolicy(): void {
    this.sharedDocumentUploadService.downloadDoc(ESharedDocumentType.PRIVACY);
  }
  goToFAQBandi() {
    this.router.navigate([RoutePath.BANDI, RoutePath.FAQ]);
  }
  goToHelpDeskBandi() {
    this.router.navigate([RoutePath.BANDI, RoutePath.HELPDESK]);
  }
}
